import { h } from "preact";
import { observer } from "mobx-react";
function ItemCountBadge({ count }) {
    if (count === 0)
        return null;
    return (h("span", { class: "m-item__cart-count" },
        h("span", { class: "m-item__badge count" }, count)));
}
export default observer(ItemCountBadge);
